import { PROFILE_UPDATE_REQUEST, PROFILE_UPDATE_FAILURE, PROFILE_UPDATE_SUCCESS, PROFILE_RESET_UPDATED} from "./constants";

const initialState = {
    updated: undefined,
    error: '',
    success: '',
    updatedUser: {},
    emailExistsError: undefined,
};

const profileReducer = (state = initialState, action) => {

    switch (action.type) {
        case PROFILE_UPDATE_REQUEST:
            return Object.assign(state, {updated: undefined, error: '', emailExistsError: undefined});
        case PROFILE_UPDATE_SUCCESS:
            return Object.assign(state, {updated: true, error: '', emailExistsError: false});
        case PROFILE_UPDATE_FAILURE:
            return Object.assign({}, state, {updated: false, error: (action.error.validationErrors) ? action.error.validationErrors.error : '', emailExistsError: true});
        case PROFILE_RESET_UPDATED:
            return Object.assign({}, state, {updated: undefined, error: '', emailExistsError: undefined});
        default: return state;
    }
};

export default profileReducer;


// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Profile/reducer.js